import type { IErrorLimitCca } from '@/shared/cca/types/ccaError.type';

export const ErrorsLimitCca: IErrorLimitCca = {
  AMOUNT_EXCEEDED_FIRST_TRANSFER_CCA: 'El monto debe ser igual o menor a $600.000 CLP para contactos nuevos',
  ELAPSED_TIME_NOT_COMPLETED_CCA: 'Deben pasar 24 horas para poder realizar un nuevo envío a este contacto',
  BY_TRANSFER: 'Puedes enviar hasta $7.000.000 CLP en una única operación',
  DEFAULT: 'No puedes enviar dinero en este momento',
} as const;
